module.exports = __webpack_public_path__ + "static/apple-touch-icon-6473b8273e9e40a3e96dc3e61a7f9791.png";